import React, { Component } from "react";
import "./App.css";
import Game from "./components/Game";

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h2>Game of Life</h2>
          <Game rows={25} columns={25} />
        </header>
      </div>
    );
  }
}

export default App;
